import { ReactNode, ReactElement } from 'react';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

export interface NoticeProps {
  type?: 'warning' | 'success';
  className?: string;
  textClassName?: string;
  icon?: ReactElement;
  iconClass?: string;
  hideIcon?: boolean;
  onClick?: () => void;
  children: ReactNode;
}

const defaultColors: Record<'warning' | 'success', string> = {
  warning: 'bg-red-50',
  success: 'bg-green-50',
};

const defaultIcons: Record<'warning' | 'success', ReactElement> = {
  warning: IconsMap.ALERT_CIRCLE,
  success: IconsMap.CHECK,
};

const defaultIconClasses: Record<'warning' | 'success', string> = {
  warning: 'text-red-500',
  success: 'text-green-500',
};

export const Notice: React.FC<NoticeProps> = ({
  type,
  className,
  textClassName,
  icon,
  iconClass,
  hideIcon = false,
  onClick,
  children,
}) => {
  const bgColor = type ? defaultColors[type] : '';
  const resolvedIcon = icon ?? (type ? defaultIcons[type] : IconsMap.ALERT_CIRCLE);
  const resolvedIconClass = iconClass ?? (type ? defaultIconClasses[type] : 'text-neutral-800');

  return (
    <div
      className={classNames(
        'flex items-start p-4 gap-3 rounded-md',
        { 'cursor-pointer': !!onClick },
        bgColor,
        className
      )}
      onClick={onClick}
    >
      {!hideIcon && resolvedIcon && (
        <Icon icon={resolvedIcon} className={classNames('shrink-0 size-5', resolvedIconClass)} />
      )}
      <div className={classNames('text-neutral-800 text-sm font-normal', textClassName)}>{children}</div>
    </div>
  );
};
